import { render, staticRenderFns } from "./NetworkIndicator.vue?vue&type=template&id=d87dd842&scoped=true&"
import script from "./NetworkIndicator.vue?vue&type=script&lang=js&"
export * from "./NetworkIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87dd842",
  null
  
)

export default component.exports